// Footer.js

import React from 'react';
import { Box, Typography } from '@mui/material';

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        mt: 6,
        py: 2,
        textAlign: 'center',
        backgroundColor: '#fffdf7',
      }}
    >
      <Typography variant="body2" sx={{ color: 'rgba(0,0,0,0.5)' }}>
        © 2026 – Bernula-Orosz Dorka
      </Typography>
    </Box>
  );
}

export default Footer;